<template>
  <router-link tag="button" :to="'/' + title" class="menuIcon">
    {{ title }}
  </router-link>
</template>

<script>
export default {
  name: 'MenuIcon',
  props: {
    title: String
  }
}
</script>

<style>
  .menuIcon {
    height: 100%;
    border: none;
    background: none;
    outline: none;
    font-size: 20px;
  }
  .menuIcon:hover, .menuIcon.router-link-active {
    box-shadow: 0 -5px 0 orange inset;
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu/MenuIcon.vue